var cov_1dtiar4mum = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Scroll/index.tsx",
      hash = "a4a2bb75fc19979e1fd4f16e8fed9fae2e6df6b1",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Scroll/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 16
        }
      },
      "1": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 22,
          column: 5
        }
      },
      "2": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 52
        }
      },
      "3": {
        start: {
          line: 28,
          column: 23
        },
        end: {
          line: 28,
          column: 33
        }
      },
      "4": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 46
        }
      },
      "5": {
        start: {
          line: 33,
          column: 23
        },
        end: {
          line: 33,
          column: 33
        }
      },
      "6": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 46
        }
      },
      "7": {
        start: {
          line: 38,
          column: 17
        },
        end: {
          line: 38,
          column: 94
        }
      },
      "8": {
        start: {
          line: 39,
          column: 16
        },
        end: {
          line: 39,
          column: 90
        }
      },
      "9": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 24
        }
      },
      "10": {
        start: {
          line: 44,
          column: 17
        },
        end: {
          line: 44,
          column: 37
        }
      },
      "11": {
        start: {
          line: 45,
          column: 16
        },
        end: {
          line: 45,
          column: 36
        }
      },
      "12": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 32
        }
      },
      "13": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 50,
          column: 5
        }
      },
      "14": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 47
        }
      },
      "15": {
        start: {
          line: 54,
          column: 26
        },
        end: {
          line: 54,
          column: 40
        }
      },
      "16": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 64,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        loc: {
          start: {
            line: 17,
            column: 39
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 16
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 27
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 16
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 32
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 12
          },
          end: {
            line: 41,
            column: 3
          }
        },
        line: 37
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 43,
            column: 2
          },
          end: {
            line: 43,
            column: 3
          }
        },
        loc: {
          start: {
            line: 43,
            column: 53
          },
          end: {
            line: 51,
            column: 3
          }
        },
        line: 43
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 53,
            column: 3
          }
        },
        loc: {
          start: {
            line: 53,
            column: 11
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 53
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 28
          }
        }, {
          start: {
            line: 20,
            column: 32
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "1": {
        loc: {
          start: {
            line: 21,
            column: 11
          },
          end: {
            line: 21,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 11
          },
          end: {
            line: 21,
            column: 26
          }
        }, {
          start: {
            line: 21,
            column: 30
          },
          end: {
            line: 21,
            column: 31
          }
        }],
        line: 21
      },
      "2": {
        loc: {
          start: {
            line: 29,
            column: 11
          },
          end: {
            line: 29,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 11
          },
          end: {
            line: 29,
            column: 25
          }
        }, {
          start: {
            line: 29,
            column: 29
          },
          end: {
            line: 29,
            column: 46
          }
        }],
        line: 29
      },
      "3": {
        loc: {
          start: {
            line: 34,
            column: 11
          },
          end: {
            line: 34,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 11
          },
          end: {
            line: 34,
            column: 25
          }
        }, {
          start: {
            line: 34,
            column: 29
          },
          end: {
            line: 34,
            column: 46
          }
        }],
        line: 34
      },
      "4": {
        loc: {
          start: {
            line: 38,
            column: 17
          },
          end: {
            line: 38,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 38,
            column: 55
          },
          end: {
            line: 38,
            column: 70
          }
        }, {
          start: {
            line: 38,
            column: 73
          },
          end: {
            line: 38,
            column: 94
          }
        }],
        line: 38
      },
      "5": {
        loc: {
          start: {
            line: 39,
            column: 16
          },
          end: {
            line: 39,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 39,
            column: 53
          },
          end: {
            line: 39,
            column: 67
          }
        }, {
          start: {
            line: 39,
            column: 70
          },
          end: {
            line: 39,
            column: 90
          }
        }],
        line: 39
      },
      "6": {
        loc: {
          start: {
            line: 44,
            column: 17
          },
          end: {
            line: 44,
            column: 37
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 44,
            column: 32
          },
          end: {
            line: 44,
            column: 33
          }
        }, {
          start: {
            line: 44,
            column: 36
          },
          end: {
            line: 44,
            column: 37
          }
        }],
        line: 44
      },
      "7": {
        loc: {
          start: {
            line: 45,
            column: 16
          },
          end: {
            line: 45,
            column: 36
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 45,
            column: 31
          },
          end: {
            line: 45,
            column: 32
          }
        }, {
          start: {
            line: 45,
            column: 35
          },
          end: {
            line: 45,
            column: 36
          }
        }],
        line: 45
      },
      "8": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        }],
        line: 47
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Scroll/index.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import Scroll from './Scroll';

var _default =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(_default, _PureComponent);

  var _super = _createSuper2(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    cov_1dtiar4mum.f[0]++;
    cov_1dtiar4mum.s[0]++;
    _this = _super.call(this, props);
    cov_1dtiar4mum.s[1]++;
    _this.state = {
      left: (cov_1dtiar4mum.b[0][0]++, props.scrollLeft) || (cov_1dtiar4mum.b[0][1]++, 0),
      top: (cov_1dtiar4mum.b[1][0]++, props.scrollTop) || (cov_1dtiar4mum.b[1][1]++, 0)
    };
    cov_1dtiar4mum.s[2]++;
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(_default, [{
    key: "getRect",
    value: function getRect() {
      cov_1dtiar4mum.f[3]++;
      var left = (cov_1dtiar4mum.s[7]++, this.props.scrollLeft === undefined ? (cov_1dtiar4mum.b[4][0]++, this.state.left) : (cov_1dtiar4mum.b[4][1]++, this.props.scrollLeft));
      var top = (cov_1dtiar4mum.s[8]++, this.props.scrollTop === undefined ? (cov_1dtiar4mum.b[5][0]++, this.state.top) : (cov_1dtiar4mum.b[5][1]++, this.props.scrollTop));
      cov_1dtiar4mum.s[9]++;
      return {
        left: left,
        top: top
      };
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(x, y) {
      cov_1dtiar4mum.f[4]++;
      var left = (cov_1dtiar4mum.s[10]++, this.scrollX ? (cov_1dtiar4mum.b[6][0]++, x) : (cov_1dtiar4mum.b[6][1]++, 0));
      var top = (cov_1dtiar4mum.s[11]++, this.scrollY ? (cov_1dtiar4mum.b[7][0]++, y) : (cov_1dtiar4mum.b[7][1]++, 0));
      cov_1dtiar4mum.s[12]++;
      this.setState({
        left: left,
        top: top
      });
      cov_1dtiar4mum.s[13]++;

      if (this.props.onScroll) {
        var _this$props;

        cov_1dtiar4mum.b[8][0]++;
        cov_1dtiar4mum.s[14]++;

        for (var _len = arguments.length, others = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          others[_key - 2] = arguments[_key];
        }

        // @ts-ignore
        (_this$props = this.props).onScroll.apply(_this$props, [left, top].concat(others));
      } else {
        cov_1dtiar4mum.b[8][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_1dtiar4mum.f[5]++;

      var _ref = (cov_1dtiar4mum.s[15]++, this.getRect()),
          left = _ref.left,
          top = _ref.top;

      cov_1dtiar4mum.s[16]++;
      return (
        /*#__PURE__*/
        React.createElement(Scroll, Object.assign({}, this.props, {
          left: left,
          top: top,
          scrollX: this.scrollX,
          scrollY: this.scrollY,
          onScroll: this.handleScroll,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 56,
            columnNumber: 7
          }
        }))
      );
    }
  }, {
    key: "scrollX",
    get: function get() {
      cov_1dtiar4mum.f[1]++;

      var _ref2 = (cov_1dtiar4mum.s[3]++, this.props),
          scroll = _ref2.scroll;

      cov_1dtiar4mum.s[4]++;
      return (cov_1dtiar4mum.b[2][0]++, scroll === 'x') || (cov_1dtiar4mum.b[2][1]++, scroll === 'both');
    }
  }, {
    key: "scrollY",
    get: function get() {
      cov_1dtiar4mum.f[2]++;

      var _ref3 = (cov_1dtiar4mum.s[5]++, this.props),
          scroll = _ref3.scroll;

      cov_1dtiar4mum.s[6]++;
      return (cov_1dtiar4mum.b[3][0]++, scroll === 'y') || (cov_1dtiar4mum.b[3][1]++, scroll === 'both');
    }
  }]);

  return _default;
}(PureComponent);

_default.displayName = 'ShineoutScroll';
_default.defaultProps = {
  scroll: 'both'
};
export { _default as default };